import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { of, Subscription } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { NotificationType } from '../../../shared/models/notification-type';
import { TermsConditions } from '../../../shared/models/terms-conditions.model';
import { ErrorHandlerService } from '../../../shared/services/error-handler/error-handler.service';
import { NotificationService } from '../../../shared/services/notification/notification.service';
import { UserService } from '../../../shared/services/user/user.service';
import { UtilityService } from '../../../shared/services/utility/utility.service';

@Component({
    selector: 'upsc-user-terms-use',
    templateUrl: './user-terms-use.component.html',
    styleUrls: ['./user-terms-use.component.scss'],
})
export class UserTermsUseComponent implements OnInit, OnDestroy {

    public termsOfUse: string;
    public isTermsLoading = false;

    private getTermsSubscription: Subscription;

    public constructor(private userService: UserService,
                       private utilityService: UtilityService,
                       private errorHandlerService: ErrorHandlerService,
                       private notificationService: NotificationService,
                       private translateService: TranslateService,
                       @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
    }

    public ngOnInit() {
        this.getTerms();
    }

    public ngOnDestroy() {
        this.utilityService.clearSubscriptions([this.getTermsSubscription]);
    }

    private getTerms() {
        if (this.data && this.data.termsOfUse) {
            this.termsOfUse = this.data.termsOfUse;
            return;
        }

        this.isTermsLoading = true;
        this.utilityService.clearSubscriptions([this.getTermsSubscription]);
        this.getTermsSubscription = this.userService.getTermsSigned()
                                        .pipe(
                                            finalize(() => {
                                                this.isTermsLoading = false;
                                            }),
                                            catchError((err) => {
                                                this.notificationService.notify(
                                                    this.errorHandlerService.getHttpErrorMessage(err),
                                                    this.translateService.instant('errorLoadingTerms'),
                                                    NotificationType.ERROR);

                                                return of(null);
                                            }),
                                        )
                                        .subscribe(
                                            (term: TermsConditions) => {
                                                this.termsOfUse = term.TermsUsage;
                                            },
                                        );
    }
}
